/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_SubtitleInputs */



/**
* | output |
* | --- |
* | "Manage organization-wide preferences, including default AI models." |
*
* @param {Admin_Settings_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_settings_subtitle = /** @type {((inputs?: Admin_Settings_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalte organisationsweite Voreinstellungen, einschließlich Standard-KI-Modellen.")
	return /** @type {LocalizedString} */ ("Manage organization-wide preferences, including default AI models.")
});